import { render, staticRenderFns } from "./v_IframeSuccessMsg.vue?vue&type=template&id=536c68e0&scoped=true&"
import script from "./v_IframeSuccessMsg.vue?vue&type=script&lang=js&"
export * from "./v_IframeSuccessMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c68e0",
  null
  
)

export default component.exports